import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import { COLORS, DOCUMENT_TYPE } from '../../../utils/Application_Constants';
import UploadClinicianDocumentV2 from '../Credentials/PageComponenets/DocumentComponents/UploadClinicianDocumentV2';

const styles = (theme) => ({
    header: {
        color: COLORS.ST_TROPAZ,
        [theme.breakpoints.down('md')]: {
            padding: '36px 0 0 15px',
        },
        textAlign: 'left',
        paddingLeft: '32px',
        paddingTop: '20px',
        fontSize: '17px',
        fontWeight: '700',
    },
    headerText: {},
    inputLabel: {
        color: COLORS.RAVEN,
        fontWeight: '900',
        fontSize: '12px',
    },
    paperRoot: {
        paddingBottom: '60px',
        marginTop: '30px',
    },
    gridRoot: {
        [theme.breakpoints.up('md')]: {
            marginLeft: '32px',
        },
        [theme.breakpoints.down('md')]: {
            margin: '5px 10px',
        },
    },
    setWidthTo100OnMobile: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    profileWrapper: {
        paddingBottom: '50px',
        borderBottom: `1px solid ${COLORS.SEASHELL}`,
    },
});

const DocTypes = [
    {
        value: DOCUMENT_TYPE.CurriculumVitae,
        label: DOCUMENT_TYPE.CurriculumVitae,
    },
];

class ManageCVV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clinicianQualifications: {},
            skillMappingList: [],
            specialtyList: [],
            cvsSelected: [],
            flags: {
                targetTab: 0,
            },
        };
    }

    markFlagsDirty = () => {
        const { flags } = this.props;
        flags.isDirty = true;
        flags.dataSaved = false;
        this.props.updateFlags(flags);
    };

    checkboxHandler = (event, index) => {
        const state = { ...this.state };
        const { name, checked } = event.target;
        state.clinicianQualifications.specialties[index][name] = checked;
        this.markFlagsDirty();
        this.setState({ ...state });
    };

    clearTags = (index) => {
        const state = { ...this.state };
        state.clinicianQualifications.specialties[index].skills = [];
        this.setState({ ...state });
    };

    autoCompleteHandler = (newValue, name, index) => {
        const state = { ...this.state };
        const newValues = [];
        newValue.forEach((item) => {
            if (typeof item === 'string') {
                newValues.push(item);
                return;
            }
            newValues.push(item.value);
        });

        if (state.clinicianQualifications.specialties[index][name] !== newValues) {
            state.clinicianQualifications.specialties[index][name] = newValues;
            this.markFlagsDirty();
        }
        this.setState({ ...state });
    };

    autoCompleteDelete = async (index, name, specialtyIndex) => {
        const state = { ...this.state };
        state.clinicianQualifications.specialties[specialtyIndex][name].splice(index, 1);
        this.markFlagsDirty();
        this.setState({ ...state });
    };

    specialitiesUpdateHandler = (specialities) => {
        const state = { ...this.state };
        state.clinicianQualifications.specialties = specialities;
        this.setState({ ...state });
    };

    certificationsUpdateHandler = (certifications) => {
        const state = { ...this.state };
        state.clinicianQualifications.certifications = certifications;
        this.setState({ ...state });
    };

    licensesUpdateHandler = (licenses) => {
        const state = { ...this.state };
        state.clinicianQualifications.stateLicenses = licenses;
        this.setState({ ...state });
    };

    stripIsNewFields(clinicianQualifications) {
        const newQualifications = { ...clinicianQualifications };
        newQualifications.specialties.forEach((item) => {
            if (item.isNew) {
                delete item.isNew;
            }
        });
        newQualifications.stateLicenses.forEach((item) => {
            if (item.isNew) {
                delete item.isNew;
            }
        });
        return newQualifications;
    }

    render() {
        const { classes, t } = this.props;

        return (
            <>
                {/* <Paper classes={{ root: classes.paperRoot }}>
          <UploadDocument documentType="Curriculum Vitae" headerText={t('profile:QUALIFICATIONS.CV')} />
        </Paper> */}
                <Paper classes={{ root: classes.paperRoot }}>
                    <Grid>
                        <Grid item xs={12}>
                            <h3 className={classes.header}>{t('tabs:PROFILE.MANAGE_CV')}</h3>
                        </Grid>
                        <Grid item xs={12} className={classes.gridRoot}>
                            <UploadClinicianDocumentV2 docTypeList={DocTypes} showDocuments />
                        </Grid>
                    </Grid>
                </Paper>
            </>
        );
    }
}

ManageCVV2.propTypes = {
    classes: PropTypes.shape({
        headerText: PropTypes.string.isRequired,
    }).isRequired,
    t: PropTypes.func.isRequired,
    tabHandler: PropTypes.func.isRequired,
    flags: PropTypes.shape({
        missingData: PropTypes.bool.isRequired,
        dataSaved: PropTypes.bool.isRequired,
        isDirty: PropTypes.bool.isRequired,
        showSaveChanges: PropTypes.bool.isRequired,
        isPendingSave: PropTypes.bool.isRequired,
        targetTab: PropTypes.number.isRequired,
    }).isRequired,
    updateFlags: PropTypes.func.isRequired,
    setSaveHandler: PropTypes.func.isRequired,
    externalId: PropTypes.number.isRequired,
};

export default withTranslation()(withStyles(styles)(ManageCVV2));
